import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  containerHeader: {
    marginTop: 30,
    marginBottom: 20,
  },
  content: {
    paddingHorizontal: 20,
  },
  spaceHorizontal: {
    paddingHorizontal: 15,
    marginBottom: 20,
  },
  text: {
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: 'black',
    marginBottom: 10,
  },
  errorText: {
    alignSelf: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16,
    color: 'red',
    marginBottom: 10,
  },
  titleDescription: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: 'black',
    marginTop: 30,
    marginBottom: 15,
  },
  description: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 10,
    maxWidth: 330,
  },
  containerButton: {
    width: '100%',
    height: 110,
    position: 'absolute',
    paddingHorizontal: 40,
    paddingRight: 80,
    bottom: 0,
    left: 0,
    right: 0,
    borderTopWidth: 1,
    borderColor: Colors.lightGray,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    backgroundColor: 'white',
  },
  textInput: {
    borderWidth: 1,
    borderColor: '#D10000',
    borderRadius: 5,
    padding: 10,
    color: 'black',
    marginHorizontal: 10,
    marginBottom: 50,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },

  card: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 10,
    marginVertical: 8,
    paddingVertical: 20,
    paddingHorizontal: 10,
    backgroundColor: '#fff',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  productText: {
    fontWeight: 'bold',
    fontSize: 16,
    color: Colors.RedPallete.red,
  },
  toggle: {
    fontSize: 18,
    color: Colors.RedPallete.red,
  },
  form: {
    marginTop: 10,
  },
  label: {
    color: '#000',
    fontWeight: 'bold',
    marginTop: 10,
  },
  quantity: {
    color: Colors.RedPallete.red,
    marginTop: 5,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    padding: 8,
    marginTop: 5,
    color: '#000',
  },
  input2: {
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 10,
    textAlign: 'center',
    flex: 1,
    fontSize: 18,
    paddingVertical: 5,
    marginTop: 8,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
  inputWrapper: {
    marginTop: 10,
  },

  picker: {
    color: '#000',
    width: '100%',
    height: 45,
  },
  quantityContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  button: {
    fontSize: 24,
    color: '#000',
    paddingHorizontal: 15,
  },
  modalContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#000',
  },
  modalContent: {
    backgroundColor: '#fff',
    padding: 20,
    borderRadius: 10,
    width: '80%',
    maxHeight: '70%',
    color: '#000',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
    textAlign: 'center',
    color: '#000',
  },
  productSummary: {
    paddingVertical: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    color: '#000',
  },
  modalButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    color: '#000',
  },
  radioOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },

  radioOptionSelected: {
    backgroundColor: '#f0f0f0',
    borderRadius: 5,
  },

  radioCircle: {
    height: 20,
    width: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#333',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },

  radioDot: {
    height: 10,
    width: 10,
    borderRadius: 5,
    backgroundColor: '#333',
  },

  radioLabel: {
    fontSize: 14,
    color: '#333',
  },
  radio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: '#D10000',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
  },
  radioSelected: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: '#D10000',
  },
});
